import React from 'react';

import { Alert, CloseButton, List, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import stringHelper from '../../../utils/stringHelper';

import { StyledListItem } from './StyledComponents';

type Props = {
  customerProblems: Array<string>;
};

const CustomerListingProblemsBanner = ({ customerProblems }: Props): JSX.Element | null => {
  if (customerProblems?.length > 0) {
    return (
      <Spacer marginBottom="md" data-test="CustomerListingProblemsBanner">
        <Alert
          appearance="warning"
          body={
            <React.Fragment>
              <Spacer marginBottom="xs">
                <Text textStyle="body-bold">
                  {stringHelper.pluralize(customerProblems.length, 'issue has', 'issues have')}
                  &nbsp;been identified on this listing:
                </Text>
              </Spacer>
              <List>
                {customerProblems.map((problem, problemIndex: number) => {
                  return <StyledListItem key={`Customer-Problems-${problemIndex}`}>{problem}</StyledListItem>;
                })}
              </List>
            </React.Fragment>
          }
          closeButton={<CloseButton />}
        />
      </Spacer>
    );
  }

  return null;
};

export default CustomerListingProblemsBanner;
